module.exports = __webpack_public_path__ + "static/media/hono.e994ddae.png";